// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ag-3";
export var contentContainer = "_ag-0";
export var editorContainer = "_ag-1";
export var quillInputForm = "_ag-2";
export var zoneDivider = "_ag-4";